import * as React from 'react';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Form, Col, Row } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { Section } from '../../uiComponents/layout/Section';
import { EmailFormGroup } from '../../uiComponents/input/FormGroups';
import { ValidationError } from '../../infrastructure/ValidationResult';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import { LinkSecondaryButton } from '../../uiComponents/input/Buttons';
import SubmitButton from '../../uiComponents/input/SubmitButton';

export interface EksternBrugerCreateNulstilPresenterProps {
    email: string;
    errorMessages: ValidationError[];
    isSubmitting: boolean;
    onSave: () => void;
    onChange: (fieldName: string, value: any) => void;
    header: string;
    title: string;
    backHref: string;
    submitBtnText: string;
}

class EksternBrugerCreateNulstilPresenter extends React.Component<EksternBrugerCreateNulstilPresenterProps, any> {
    constructor(props: EksternBrugerCreateNulstilPresenterProps) {
        super(props);
    }

    render() {
        return (
            <PageWrapper>
                <PageTitle title={this.props.title} />
                <ContentWrapper>
                    <SectionGroup header={this.props.header}>
                        <Form onSubmit={this.props.onSave}>
                            <Section>
                                <Row>
                                    <Col md={6} mdOffset={3}>
                                        <EmailFormGroup 
                                            errorMessages={this.props.errorMessages === undefined ? [] : this.props.errorMessages}
                                            label='Email*'
                                            name='email'
                                            placeholder='Indtast email'
                                            value={this.props.email}
                                            onChange={this.props.onChange}
                                            autoFocus={true}
                                        />
                                    </Col>
                                </Row>
                            </Section>
                            <ButtonSection>
                                <LinkSecondaryButton className='spacer' url={this.props.backHref} text='Fortryd' />
                                <SubmitButton isSubmitting={this.props.isSubmitting}>{this.props.isSubmitting ? 'Vent...' : this.props.submitBtnText}</SubmitButton>
                            </ButtonSection>
                        </Form>
                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default EksternBrugerCreateNulstilPresenter;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/eksternAdgang/EksternBrugerCreateNulstilPresenter.tsx